/**
 * Translations Configuration
 * Add this script to your theme's default.hbs before multilingual.js
 */

window.multilangTranslations = {
    en: {
        //misc
        'misc.themes': 'Themes',
        'misc.book': 'Book',
        'misc.subthemes': 'Themes with reading samples',
        'misc.leseproben': 'Reading samples',
        'misc.klappentext': 'Blurb',


        // Navigation
        'nav.home': 'Home',
        'nav.about': 'About',
        'nav.contact': 'Contact',
        'nav.blog': 'Blog',
        'nav.archive': 'Archive',
        
        // Common UI
        'ui.read_more': 'Read more',
        'ui.continue_reading': 'Continue reading',
        'ui.published': 'Published',
        'ui.updated': 'Updated',
        'ui.by': 'by',
        'ui.in': 'in',
        'ui.tagged': 'Tagged',
        'ui.min_read': 'min read',
        
        // Search
        'search.placeholder': 'Search...',
        'search.no_results': 'No results found',
        'search.results': 'results',
        
        // Pagination
        'pagination.newer': 'Newer Posts',
        'pagination.older': 'Older Posts',
        'pagination.page': 'Page',
        'pagination.of': 'of',
        
        // Comments
        'comments.title': 'Comments',
        'comments.no_comments': 'No comments yet',
        'comments.be_first': 'Be the first to comment',
        
        // Newsletter
        'newsletter.title': 'Subscribe',
        'newsletter.description': 'Get the latest posts delivered right to your inbox',
        'newsletter.email_placeholder': 'Your email address',
        'newsletter.subscribe': 'Subscribe',
        'newsletter.success': 'Thanks for subscribing!',
        'newsletter.error': 'Subscription failed. Please try again.',
        
        // Author
        'author.posts_by': 'Posts by',
        'author.website': 'Website',
        'author.location': 'Location',
        
        // Tags
        'tags.all': 'All Tags',
        'tags.posts_tagged': 'Posts tagged',
        
        // Dates
        'date.january': 'January',
        'date.february': 'February',
        'date.march': 'March',
        'date.april': 'April',
        'date.may': 'May',
        'date.june': 'June',
        'date.july': 'July',
        'date.august': 'August',
        'date.september': 'September',
        'date.october': 'October',
        'date.november': 'November',
        'date.december': 'December',
        
        // Footer
        'footer.copyright': 'All rights reserved',
        'footer.powered_by': 'Powered by Ghost',
        
        // Errors
        'error.404': 'Page not found',
        'error.404_message': 'The page you are looking for doesn\'t exist.',
        'error.go_home': 'Go to homepage',
        
        // Share
        'share.title': 'Share this post',
        'share.twitter': 'Share on Twitter',
        'share.facebook': 'Share on Facebook',
        'share.linkedin': 'Share on LinkedIn',
        'share.email': 'Share via Email',
        'share.copy_link': 'Copy link',
        'share.link_copied': 'Link copied!'
    },
    
    de: {
        //misc
        'misc.themes': 'Themen',
        'misc.book': 'Buch',
        'misc.subthemes': 'Themen der Publikationen mit Leseproben',
        'misc.leseproben': 'Leseproben',
        'misc.klappentext': 'Klappentext',
        // Navigation
        'nav.home': 'Startseite',
        'nav.about': 'Über uns',
        'nav.contact': 'Kontakt',
        'nav.blog': 'Blog',
        'nav.archive': 'Archiv',
        
        // Common UI
        'ui.read_more': 'Mehr lesen',
        'ui.continue_reading': 'Weiterlesen',
        'ui.published': 'Veröffentlicht',
        'ui.updated': 'Aktualisiert',
        'ui.by': 'von',
        'ui.in': 'in',
        'ui.tagged': 'Markiert',
        'ui.min_read': 'Min. Lesezeit',
        
        // Search
        'search.placeholder': 'Suchen...',
        'search.no_results': 'Keine Ergebnisse gefunden',
        'search.results': 'Ergebnisse',
        
        // Pagination
        'pagination.newer': 'Neuere Beiträge',
        'pagination.older': 'Ältere Beiträge',
        'pagination.page': 'Seite',
        'pagination.of': 'von',
        
        // Comments
        'comments.title': 'Kommentare',
        'comments.no_comments': 'Noch keine Kommentare',
        'comments.be_first': 'Sei der Erste, der kommentiert',
        
        // Newsletter
        'newsletter.title': 'Abonnieren',
        'newsletter.description': 'Erhalte die neuesten Beiträge direkt in dein Postfach',
        'newsletter.email_placeholder': 'Deine E-Mail-Adresse',
        'newsletter.subscribe': 'Abonnieren',
        'newsletter.success': 'Vielen Dank für dein Abonnement!',
        'newsletter.error': 'Abonnement fehlgeschlagen. Bitte versuche es erneut.',
        
        // Author
        'author.posts_by': 'Beiträge von',
        'author.website': 'Webseite',
        'author.location': 'Standort',
        
        // Tags
        'tags.all': 'Alle Tags',
        'tags.posts_tagged': 'Beiträge mit Tag',
        
        // Dates
        'date.january': 'Januar',
        'date.february': 'Februar',
        'date.march': 'März',
        'date.april': 'April',
        'date.may': 'Mai',
        'date.june': 'Juni',
        'date.july': 'Juli',
        'date.august': 'August',
        'date.september': 'September',
        'date.october': 'Oktober',
        'date.november': 'November',
        'date.december': 'Dezember',
        
        // Footer
        'footer.copyright': 'Alle Rechte vorbehalten',
        'footer.powered_by': 'Betrieben mit Ghost',
        
        // Errors
        'error.404': 'Seite nicht gefunden',
        'error.404_message': 'Die Seite, die du suchst, existiert nicht.',
        'error.go_home': 'Zur Startseite',
        
        // Share
        'share.title': 'Diesen Beitrag teilen',
        'share.twitter': 'Auf Twitter teilen',
        'share.facebook': 'Auf Facebook teilen',
        'share.linkedin': 'Auf LinkedIn teilen',
        'share.email': 'Per E-Mail teilen',
        'share.copy_link': 'Link kopieren',
        'share.link_copied': 'Link kopiert!'
    }
};

/**
 * UI Translations
 * This file is loaded early in <head> so translations are available immediately
 * Individual translation partials handle their own translation inline
 */

/**
 * Cart Translations
 * Shopping cart UI element translations
 *
 * HOW TO MODIFY CART TRANSLATIONS:
 *
 * 1. To change existing text, edit the value for the key:
 *    Example: cart_title: "My Shopping Basket" (instead of "Shopping Cart")
 *
 * 2. To add a new language, add a new language block with all keys:
 *    Example: es: { cart_title: "Carrito", cart_empty: "Tu carrito está vacío", ... }
 *
 * 3. To add a new translation key (for new features):
 *    - Add the key to ALL language blocks
 *    - Use it in cart.hbs with: t("your_new_key")
 *
 * Available keys:
 * - cart_title, cart_empty, total, checkout, processing
 * - add_to_cart, checkout_error, digital_product, physical_product
 * - available_formats, product_not_available, added_to_cart, view_cart
 */
window.cartTranslations = {
    en: {
        cart_title: "Shopping Cart",
        cart_empty: "Your cart is empty",
        total: "Total:",
        checkout: "Go to Checkout",
        processing: "Processing...",
        add_to_cart: "Add to Cart",
        checkout_error: "Checkout failed. Please try again.",
        digital_product: "Digital Download",
        physical_product: "Physical Product",
        available_formats: "Available formats:",
        product_not_available: "Product not available",
        added_to_cart: "Added to cart!",
        view_cart: "View Cart",
        additional_buy_options: "Additional Buy Options",
        on: "on"
    },
    de: {
        cart_title: "Warenkorb",
        cart_empty: "Ihr Warenkorb ist leer",
        total: "Gesamt:",
        checkout: "Zur Kasse gehen",
        processing: "Verarbeiten...",
        add_to_cart: "In den Warenkorb",
        checkout_error: "Fehler beim Checkout. Bitte versuchen Sie es erneut.",
        digital_product: "Digitales Produkt",
        physical_product: "Physisches Produkt",
        available_formats: "Verfügbare Formate:",
        product_not_available: "Produkt nicht verfügbar",
        added_to_cart: "Zum Warenkorb hinzugefügt!",
        view_cart: "Warenkorb ansehen",
        additional_buy_options: "Weitere Kaufoptionen",
        on: "bei"
    }
};

/**
 * Retranslate all translation partials when language changes
 */
document.addEventListener('languageChanged', function(e) {
    var lang = e.detail.language;
    var translations = window.multilangTranslations[lang] || {};

    // Update all translated elements
    document.querySelectorAll('[data-tr-key]').forEach(function(el) {
        var key = el.getAttribute('data-tr-key');
        var defaultText = el.getAttribute('data-tr-default');

        if (translations[key]) {
            el.textContent = translations[key];
            el.setAttribute('data-tr-lang', lang);
        } else {
            // Fallback to default
            el.textContent = defaultText;
            el.removeAttribute('data-tr-lang');
        }
    });
});